import { RollupWithTagsAndCountsAndRange, TimeRangeFinite } from "types/types";
import {
  CENTER_LABEL_HEIGHT,
  TITLE_LABEL_HEIGHT,
  COUNT_HEIGHT,
  TREND_CHART_BAR_PADDING_VERT,
  BARSTACK_PADDING_TOP,
} from "../../../TrendChartStyles";
import {
  useShowTrendLineOnThisPage,
  useTrendLineSegment,
} from "../TrendLine/trendLineUtils";
import TrendLineSegment from "./TrendLineSegment";
import { useRollupMetricForBarRange } from "../trendChartBarUtils";
import { useMemo } from "react";
import { useFlightConfig } from "components/DataGetter/FlightConfig/useFlightConfig";

export function TrendLineSegmentWrapper(props) {
  const [{ trendChart }] = useFlightConfig();
  const showTrendLine = trendChart?.showTrendLine;
  // skip if trend line is not configured
  return showTrendLine ? <TrendLineSegmentWrapperContent {...props} /> : null;
}
function TrendLineSegmentWrapperContent({
  barDataRange,
  range,
  rollupMetric,
  overridePrevRollupMetric,
  showOutputCount,
  shouldHideProfitCategories,
}: {
  barDataRange: TimeRangeFinite;
  range: TimeRangeFinite;
  rollupMetric: RollupWithTagsAndCountsAndRange;
  overridePrevRollupMetric?: RollupWithTagsAndCountsAndRange | null;
  showOutputCount: boolean;
  shouldHideProfitCategories: boolean;
}) {
  const prevBarRange = {
    ge: range.ge - (range.lt - range.ge),
    lt: range.ge,
  };
  const storedPrevRollupMetric = useRollupMetricForBarRange(prevBarRange);
  const prevRollupMetric = overridePrevRollupMetric || storedPrevRollupMetric;

  const firstBarAndLabel = document.querySelector(".trend-chart-bar");
  const barAndLabelsHeight =
    firstBarAndLabel?.getBoundingClientRect().height || 480;
  const barHeight = useMemo(() => {
    return (
      (barAndLabelsHeight -
        (CENTER_LABEL_HEIGHT +
          TITLE_LABEL_HEIGHT +
          BARSTACK_PADDING_TOP +
          (showOutputCount ? COUNT_HEIGHT : 0) +
          2 * TREND_CHART_BAR_PADDING_VERT)) /
      // if both top and bottom of the chart are visible, divide height in half
      (shouldHideProfitCategories ? 1 : 2)
    );
  }, [showOutputCount, shouldHideProfitCategories, barAndLabelsHeight]);

  const { shouldShowTrendLine } = useTrendLineSegment({
    rollupMetric,
    barRange: barDataRange,
    barHeight,
    prevRollupMetric,
  });
  const showTrendLine = useShowTrendLineOnThisPage() && shouldShowTrendLine;

  return showTrendLine ? (
    <TrendLineSegment
      barRange={barDataRange}
      barHeight={barHeight}
      rollupMetric={rollupMetric}
      prevRollupMetric={prevRollupMetric}
    />
  ) : null;
}
